import React from "react";
import { Icon } from "antd";
import { SunYellow } from "../../styles/Colours";

export const FooterText = () => {
  return (
    <div>
      &copy; 2020 EFRS | Developed with{" "}
      <Icon
        type="heart"
        style={{ color: SunYellow, fontSize: "14px" }}
        theme="filled"
      />{" "}
      by{" "}
      <a href="https://setima.pt" target="_blank" rel="noopener noreferrer">
        Sétima Web & Mobile Apps
      </a>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/layout/FooterText.js